import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2AccountInstructions = loadable(
  () => import('./PSD2AccountInstructions'),
  {
    fallback: <Loader />,
  },
);
